import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
import {isLoggedIn } from '../utils/AuthService';
import '../App.css';

class MainPage extends Component {


  render() {
  return (
    <div>

      <Nav />

      {
        ( !isLoggedIn() ) ? (<div>
        <br/>
        <br/>
        <br/>
        <center><h1>Zaloguj się</h1></center>
      </div>) : ''
      }
    </div>
  );
}
}

export default MainPage;



// WEBPACK FOOTER //
// ./src/components/MainPage.js